import type * as Immutable from 'immutable';

import useViewsSelector from 'views/stores/useViewsSelector';
import { selectUndeclaredParameters } from 'views/logic/slices/searchMetadataSelectors';

const useUndeclaredParameters = (): Immutable.Set<string> => useViewsSelector(selectUndeclaredParameters);

export default useUndeclaredParameters;
